{
  "loading": "Yükleniyor...",
  "placeholder": "Seçin…"
}
